import '../main.less';
import PropTypes from 'prop-types';
import React from 'react';
import ModalBox from '../../../../shared/modal';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';
import Input from '../../../../shared/form-elements/input';
import { formatMoney } from '../../../../shared/format';

const Form = props => {
	const { selectOptions, disabledFields, shouldAllowFloats } = props.createPayoutFormData;
	const submit = data => props.createPayoutFormSubmit(data);
	const shouldDisabled = prepareDisabledFields(disabledFields);

	return (
		<div className="payouts-transaction-form-wrap payouts-form-in-modal">
			<form className="ui-form payouts-form__main clearfix" onSubmit={props.handleSubmit(submit)}>
				<div className="payouts-form__main-fields">
					<div className="ui-form__element affiliates">
						<Field
							name="affiliate_id"
							placeholder={props.intl('Affiliate')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.affiliatesLookups}
							onChange={props.createPayoutFormGetAffiliateSettings}
							disabled={shouldDisabled('affiliate_id')}
						/>
					</div>
					<div className="ui-form__element payout-system">
						<Field
							name="payout_setting_id"
							placeholder={props.intl('Payout setting')}
							component={SelectField}
							searchable={false}
							multi={false}
							options={selectOptions.payoutSettings}
							disabled={shouldDisabled('payout_setting_id')}
							onChange={props.updateAmount}
						/>
					</div>
					<div className="ui-form__element amount">
						<Field
							name="amount"
							placeholder={props.intl('Amount')}
							component={Input}
							disabled={shouldDisabled('amount')}
							normalize={value => formatMoney(value, shouldAllowFloats)}
						/>
					</div>
				</div>
				<button type="submit" className="ui-btn ui-btn-primary apply">
					{props.intl('Apply')}
				</button>
				<button
					className="ui-btn ui-btn-cancel cancel"
					onClick={e => {
						e.preventDefault();
						props.toggleCreatePayoutForm();
					}}
				>
					{props.intl('Cancel')}
				</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	createPayoutFormData: PropTypes.object,
	handleSubmit: PropTypes.func,
	createPayoutFormSubmit: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	createPayoutFormGetAffiliateSettings: PropTypes.func,
	toggleCreatePayoutForm: PropTypes.func,
	updateAmount: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func
};

const prepareDisabledFields = disabledFields => fieldName => disabledFields.indexOf(fieldName) > -1;

const Main = props =>
	<ModalBox
		title={props.intl('Create a payout for affiliate')}
		body={Form(props)}
		isOpen={props.createPayoutShouldShowStatus}
		onClose={props.toggleCreatePayoutForm}
		className="form-modal"
	/>;

Main.propTypes = {
	createPayoutFormData: PropTypes.object,
	createPayoutShouldShowStatus: PropTypes.bool,
	toggleCreatePayoutForm: PropTypes.func,
	intl: PropTypes.func
};

export default formName => reduxForm({ form: formName })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/forms/create-payout/main.js